// iframe-auth.service.ts
import { inject, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHelperService } from '../../shared/services/http.service';

@Injectable({ providedIn: 'root' })
export class IframeAuthService {
  private http = inject(HttpHelperService);
  isAuthenticated = signal(false);
  isLoading = signal(true);
  private accessToken: string | null = null;
  private expiresOn: Date | null = null;

  setTokenFromHost(payload: any): void {
    this.accessToken = payload.access_token;
    this.expiresOn = payload.expiresOn ? new Date(payload.expiresOn) : null;
    this.isAuthenticated.set(true);
    this.isLoading.set(false);
  }

  getToken(): string | null {
    return this.accessToken;
  }

  isTokenValid(): boolean {
    return !!this.accessToken && (!this.expiresOn || this.expiresOn.getTime() > Date.now() + 60000);
  }

  getConfiguratorToken(): Observable<any> {
    return this.http.get(`api/GetConfiguratorToken`);
  }
}
